import { GridUtils } from '@/shared/util/grid-utils'

const getFullTranslationKey = key => `grossing.sidebar.${key}`
export const GROSSING_TASK = {
    TO_BE_PROCESSED: { code: 'TO_BE_PROCESSED', url: 'toBeProcessed' },
    TO_BE_REPROCESSED: { code: 'TO_BE_REPROCESSED', url: 'toBeReprocessed' },
    TO_BE_UNARCHIVED_FOR_REGROSSING: { code: 'TO_BE_UNARCHIVED_FOR_REGROSSING', url: 'toBeUnarchivedForRegrossing' },
    TO_BE_PROCESSED_OR_REPROCESSED: { code: 'TO_BE_PROCESSED_OR_REPROCESSED', url: 'toBeProcessedOrReprocessed' },
    TO_BE_ARCHIVED: { code: 'TO_BE_ARCHIVED', url: 'toBeArchivedProcessed' },
    PROCESSED: { code: 'PROCESSED', url: 'processed' }
}

export default {
    sideBarName: 'GrossingSideBar',
    expanded: [
        {
            id: 'pendingSamples',
            label: getFullTranslationKey('pendingSamples'),
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'forGrossing',
                    label: getFullTranslationKey('forGrossing'),
                    alticon: 'icon-scalpel-menu',
                    uicomponent: 'uicomponent.grossing.filter.toBeProcessed',
                    task: GROSSING_TASK.TO_BE_PROCESSED,
                    summary: true
                },
                {
                    id: 'forRegrossing',
                    label: getFullTranslationKey('forRegrossing'),
                    alticon: 'icon-scalpel-reload',
                    uicomponent: 'uicomponent.grossing.filter.toBeReprocessed',
                    task: GROSSING_TASK.TO_BE_REPROCESSED,
                    summary: true
                },
                {
                    id: 'takeOutFromArchive',
                    label: getFullTranslationKey('forTakeOut'),
                    icon: ['fal', 'inbox-out'],
                    uicomponent: 'uicomponent.grossing.filter.toBeUnarchivedForRegrossing',
                    task: GROSSING_TASK.TO_BE_UNARCHIVED_FOR_REGROSSING,
                    summary: true
                },
                {
                    id: 'forFiling',
                    label: getFullTranslationKey('forFiling'),
                    icon: ['fal', 'inbox-in'],
                    uicomponent: 'uicomponent.grossing.filter.toBeArchived',
                    task: GROSSING_TASK.TO_BE_ARCHIVED,
                    summary: true
                }
            ]
        },
        {
            id: 'shelves',
            label: getFullTranslationKey('shelves'),
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'immediate',
                    label: getFullTranslationKey('immediate'),
                    icon: ['fal', 'exclamation-circle'],
                    uicomponent: 'uicomponent.grossing.filter.toBeProcessedOrReprocessed.immediate',
                    task: GROSSING_TASK.TO_BE_PROCESSED_OR_REPROCESSED,
                    filterModel: {
                        samVirtualShelf: GridUtils.getSetFilterModel(['1'])
                    },
                    summary: true
                },
                {
                    id: 'intermediate',
                    label: getFullTranslationKey('intermediate'),
                    icon: ['fal', 'minus-circle'],
                    uicomponent: 'uicomponent.grossing.filter.toBeProcessedOrReprocessed.intermediate',
                    task: GROSSING_TASK.TO_BE_PROCESSED_OR_REPROCESSED,
                    filterModel: {
                        samVirtualShelf: GridUtils.getSetFilterModel(['3'])
                    },
                    summary: true
                },
                {
                    id: 'delayed',
                    label: getFullTranslationKey('delayed'),
                    icon: ['fal', 'pause-circle'],
                    uicomponent: 'uicomponent.grossing.filter.toBeProcessedOrReprocessed.delayed',
                    task: GROSSING_TASK.TO_BE_PROCESSED_OR_REPROCESSED,
                    filterModel: {
                        samVirtualShelf: GridUtils.getSetFilterModel(['2'])
                    },
                    summary: true
                },
                {
                    id: 'autopsies',
                    label: getFullTranslationKey('autopsies'),
                    icon: ['fal', 'user-tag'],
                    uicomponent: 'uicomponent.grossing.filter.toBeProcessedOrReprocessed.autopsies',
                    task: GROSSING_TASK.TO_BE_PROCESSED_OR_REPROCESSED,
                    filterModel: {
                        samVirtualShelf: GridUtils.getSetFilterModel(['4'])
                    },
                    summary: true
                }
            ]
        },
        {
            id: 'grossing',
            label: getFullTranslationKey('grossedSamples'),
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'grossingToday',
                    label: getFullTranslationKey('grossingToday'),
                    icon: ['fal', 'calendar-day'],
                    uicomponent: 'uicomponent.grossing.filter.processed',
                    task: GROSSING_TASK.PROCESSED,
                    filterModel: {
                        lastGrossingDate: GridUtils.getTodayDateFilterModel()
                    }
                },
                {
                    id: 'grossingThisWeek',
                    label: getFullTranslationKey('grossingThisWeek'),
                    icon: ['fal', 'calendar-week'],
                    uicomponent: 'uicomponent.grossing.filter.processed',
                    task: GROSSING_TASK.PROCESSED,
                    filterModel: {
                        lastGrossingDate: GridUtils.getThisWeekDateFilterModel()
                    }
                },
                {
                    id: 'grossingThisMonth',
                    label: getFullTranslationKey('grossingThisMonth'),
                    icon: ['fal', 'calendar-alt'],
                    uicomponent: 'uicomponent.grossing.filter.processed',
                    task: GROSSING_TASK.PROCESSED,
                    filterModel: {
                        lastGrossingDate: GridUtils.getThisMonthDateFilterModel()
                    }
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'scalpel-path'],
        name: 'global.grossing'
    }
}
